import * as React from 'react';

import { AuthNotification } from '../../components/AuthNotification';
import { useAuth } from './hooks';

export const AuthNotificationContainer: React.FC = () => {
  const onAuthClick = useAuth();

  return <AuthNotification onAuthClick={onAuthClick} />;
};
